var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(!_vm.embedded && !_vm.isScreenshot)?_c('Navbar'):_vm._e(),_vm._v(" "),_c('section',{staticClass:"page-frame",style:(_vm.styleObj)},[_vm._t("default")],2),_vm._v(" "),(!_vm.embedded && !_vm.isScreenshot)?_c('FooterHero'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }